import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { PrivacyPolicyComponent } from '@app-shared/components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsDialogComponent } from '@app-shared/components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.css'],
})
export class OnboardingComponent implements OnInit {
 

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private targetExamService: BoardsService,
    private router: Router
  ) {}

  signupForm!: FormGroup;
  userItem: any;
  grades: any = [];
  grade: any;

  ngOnInit(): void {
    this.userItem = JSON.parse(
      localStorage?.getItem('user_details_from_server')
    );
    this.createSignupForm();
    this.fetchGradesList();
  }

  openTermsAndConditionsDialog(): void {
    const config: MatDialogConfig = {
      width: '800px',
      height: '94vh',
      panelClass: 'terms-condition-modalbox',
      data: { message: 'Terms of Use' },
    };
    const dialogRef = this.dialog.open(
      TermsAndConditionsDialogComponent,
      config
    );
  }

  openPrivacyPolicyDialog() {
    const config: MatDialogConfig = {
      width: '800px',
      height: '94vh',
      panelClass: 'terms-condition-modalbox',
      data: { message: 'Terms of Use' },
    };
    const dialogRef = this.dialog.open(PrivacyPolicyComponent, config);
  }

  createSignupForm() {
    this.signupForm = this.fb?.group({
      firstName: [
        this.userItem?.firstName && this.userItem?.firstName?.trim() != 'ildefaultfield' ? this.userItem?.firstName : '',
        [Validators.required],
      ],
      lastName: [
        this.userItem?.lastName && this.userItem?.lastName?.trim() != 'ildefaultfield' ? this.userItem?.lastName : '',
        [Validators.required],
      ],
      whatsappConsent: [true, [Validators.required]],
      gradeId: [
        this.userItem?.grade?.gradeId ? this.userItem?.grade?.gradeId : '',
        [Validators.required],
      ],
    });
  }

  fetchGradesList() {
    this.targetExamService?.fetchGradesList()?.subscribe((data: any) => {
      this.grades = data;
    });
  }

  checked(grade) {
    return this.reg?.gradeId?.value == grade?.gradeId;
  }

  get reg() {
    return this.signupForm?.controls;
  }

  selectedGrade(grade) {
    this.grade = grade;
    this.signupForm?.get('gradeId')?.setValue(grade?.gradeId);
  }

  goToExam() {
    if(this.userItem){
      this.userItem.firstName = this.signupForm?.controls?.firstName?.value;
      this.userItem.lastName = this.signupForm?.controls?.lastName?.value;
      this.userItem.grade = this.grade || this.userItem?.grade;
      localStorage.setItem(
        apisDataCacheKeys?.userDetails,
        JSON.stringify(this.userItem)
      );
  
      this.router.navigate(['/target-exam'], {
        state: { urlData: this.userItem },
      });
    }
  }

  checkIlDefaultFields(){
    return (this.userItem?.firstName.trim() === 'ildefaultfield') || (this.userItem?.lastName.trim() === 'ildefaultfield') || !this.userItem?.firstName || !this.userItem?.lastName
  }
}
